module.exports = __webpack_public_path__ + "static/media/Dikaiwsi_6.f15dfc8d.jpg";